export const colors = {
    blue: '#1e70a1',
    red: '#f24011',
    yellow: '#ff9e1b',
    green: '#14872c',
}

export const typography = {
    // eslint-disable-next-line @internations/curly-quotes
    fontFamilyDefault: '"Open Sans", sans-serif',
    fontFamilyBrand: 'Bryant, sans-serif',
}

/**
 * The base URL for the frontend assets. Should match the one in `frontend/util/assets.ts`.
 */
export const baseUrl = process.env.FRONTEND_ASSET_BASE_URL || '/'
